import { createSlice } from '@reduxjs/toolkit';
import { AppThunk } from './store';
import { apiString as API_URL } from '../utils/constants';
import axios from 'axios';
import b64toBlob from 'b64-to-blob';
import { setDownLoading, setIsLoading } from './shared.slice';
import { dateFormatter } from '../utils/timeFormat';

const populationUploadReport = createSlice({
    name: 'populationUploadReport',
    initialState: {
        rowData: [],
        memberData: [],
        modalVisibility: false,
        isExporting: false,
    },
    reducers: {
        _setRowData(state, action) {
            state.rowData = action.payload;
        },
        _setMemberData(state, action) {
            state.memberData = action.payload;
        },
        _setModalVisibility(state, action) {
            state.modalVisibility = action.payload;
        },
        _setIsExporting(state, action) {
            state.isExporting = action.payload;
        },
    },
});

const { _setRowData, _setMemberData, _setModalVisibility, _setIsExporting } = populationUploadReport.actions;

export const resetData = (): AppThunk => (dispatch) => {
    dispatch(_setRowData([]));
    dispatch(_setMemberData([]));
    dispatch(_setModalVisibility(false));
};

export const setModalVisibility =
    (value: boolean): AppThunk =>
    (dispatch) => {
        dispatch(_setModalVisibility(value));
    };

export const fetchPopulationUploadHistoryReport =
    (healthPlan: string, dateFrom: Date, dateTo: Date): AppThunk =>
    async (dispatch) => {
        dispatch(setIsLoading(true));
        const response = await axios.get(
            `${API_URL}/populationuploadreport/getpopulationuploadhistoryreport?healthPlan=${healthPlan}&start=${dateFormatter(dateFrom)}&end=${dateFormatter(
                dateTo
            )}`
        );
        dispatch(_setRowData(response.data));
        dispatch(setIsLoading(false));
    };

export const exportPopulationUploadHistoryReport =
    (healthPlan: string, dateFrom: Date, dateTo: Date, selectedPopulations: any): AppThunk =>
    async (dispatch) => {
        dispatch(setDownLoading(true));
        const response = await axios.get(
            `${API_URL}/populationuploadreport/exportpopulationuploadhistoryreport?healthPlan=${healthPlan}&start=${dateFormatter(
                dateFrom
            )}&end=${dateFormatter(dateTo)}&selectedPopulations=${selectedPopulations}`
        );
        let blob = b64toBlob(response.data.base64String, 'text/csv');
        let url = window.URL.createObjectURL(blob);
        let link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `${Date.now()}.xlsx`);
        link.click();
        link.remove();
        dispatch(setDownLoading(false));
    };

export const fetchMembersByPopulation =
    (id: string): AppThunk =>
    async (dispatch) => {
        dispatch(setIsLoading(true));
        const response = await axios.get(`${API_URL}/populationuploadreport/getmembersbypopulation?id=${id}`);
        dispatch(_setMemberData(response.data));
        dispatch(setIsLoading(false));
        dispatch(setModalVisibility(true));
    };

export const exportUploadedMembersByPopulation =
    (id: string): AppThunk =>
    async (dispatch) => {
        dispatch(_setIsExporting(true));
        const response = await axios.get(`${API_URL}/populationuploadreport/exportuploadmembersbypopulation?id=${id}`);
        let blob = b64toBlob(response.data.base64String, 'text/csv');
        let url = window.URL.createObjectURL(blob);
        let link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `${Date.now()}.xlsx`);
        link.click();
        link.remove();
        dispatch(_setIsExporting(false));
    };

export default populationUploadReport.reducer;
